import * as wjGrid from '@mescius/wijmo.grid';

export enum GridDragTypes {
    REORDER = 'reorder',
    ADD = 'add',
}
export class CustomMergeManager extends wjGrid.MergeManager {
    override getMergedRange(p: wjGrid.GridPanel, r: number, c: number, _clip: boolean = true) {
        if (!(c === 4 || c === 3)) return null;
        const row = p?.rows[r]?.dataItem;
        if (row?.Guid === '0' || row?.Guid === null) return null;
        // create basic cell range
        let rng = null;
        //
        // start with single cell
        rng = new wjGrid.CellRange(r, c);
        const pcol = c > 0 ? c + 1 : c;
        //
        // get reference values to use for merging
        const val = p.getCellData(r, c, false);
        const pval = p.getCellData(r, pcol, false);

        //
        // expand up
        while (rng.row > 0 && p.getCellData(rng.row - 1, c, false) === val && p.getCellData(rng.row - 1, pcol, false) === pval) {
            rng.row--;
        }
        //
        // expand down
        while (rng.row2 < p.rows.length - 1 && p.getCellData(rng.row2 + 1, c, false) === val && p.getCellData(rng.row2 + 1, pcol, false) === pval) {
            rng.row2++;
        }
        //
        // don't bother with single-cell ranges
        if (rng.isSingleCell) {
            rng = null;
        }
        //
        // done
        return rng;
    }
}

export const generateNewSlug = (prefix: string, existingSlugs: string[], titleSeparator: string, userName: string): string => {
    let row = 1;
    let strVal: string[] = [];
    for (const slug of existingSlugs) {
        if (slug) {
            const slugPrefix = slug.split(titleSeparator)[0];
            if (slugPrefix.includes(prefix)) {
                const strSubStr1 = slug.substring(0, prefix.length);
                if (strSubStr1 === prefix) {
                    let strSubStr = slug.substring(prefix.length);
                    strSubStr = strSubStr.trimStart();
                    strVal = strSubStr.split(' ');
                    if (strVal.length > 1 && !isNaN(parseInt(strVal[0])) && row <= parseInt(strVal[0])) {
                        row = parseInt(strVal[0]) + 1;
                    }
                }
            }
        }
    }
    return `${prefix} ${row} ${userName}`;
};
